module.exports = __webpack_public_path__ + "img/finance.da07565b.jpeg";